import { render } from "./PlatformReviewListPage.vue?vue&type=template&id=2bb0854b"
import script from "./PlatformReviewListPage.vue?vue&type=script&lang=js"
export * from "./PlatformReviewListPage.vue?vue&type=script&lang=js"
script.render = render

export default script